module.exports = __webpack_public_path__ + "img/shenpi.ec499615.png";